/* eslint-disable @nx/workspace/cds-react-no-missing-component-files */
/**
 * This is a component that will abstract away the PushCell implementation details from consumers.
 * A Story file will exist for PushCell implementation files, but not this interface.
 */
import React from 'react'

import { PushIcon } from '@arcade/web/icons/react'

import { BaseCellProps } from '../BaseCell/BaseCell'
import InteractiveCell from '../InteractiveCell/InteractiveCell'

export interface PushCellProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, Pick<BaseCellProps, 'label'> {
  cellProps?: Omit<BaseCellProps, 'disabled' | 'label' | 'accessory'>
  'data-testid'?: string
}

const PushCell = React.forwardRef<HTMLDivElement, PushCellProps>(
  ({ label, disabled = false, cellProps, 'data-testid': dataTestId, ...restProps }, ref) => {
    return (
      <InteractiveCell
        ref={ref}
        label={label}
        aria-label={label}
        disabled={disabled}
        cellProps={{
          accessory: <PushIcon variant={disabled ? 'disabled' : 'standard'} data-testid={`${dataTestId}-push-icon`} />,
          cellTestId: dataTestId,
          ...cellProps,
        }}
        {...restProps}
      />
    )
  }
)

export default PushCell
